module.exports = __webpack_public_path__ + "img/sale.4f6c93a2.png";